export default [
  'Percentage',
  '4-point GPA',
  '5-point GPA',
  '6-point GPA',
  '7-point GPA',
  'A-Level Letter Grade',
  'O-Level Letter Grade',
  'Benin 20-point GPA',
  'Botswana Class Grade',
  'Botswana GCSE Points Grade',
  'Botswana GCSE Letter Grade',
  'British Class Grade',
  'Cambridge Number Grade',
  'Cameroon Letter Grade',
  'Cameroon Point Grade',
  'International Baccalaureate Point Grade',
  'KCSE Letter Grade',
  'Kenyan Class Grade',
  'Kenyan Letter Grade',
  'Liberian 4-point GPA',
  'Nigerian 4-point GPA',
  'Nigerian 5-point GPA',
  'Ugandan 5-point GPA',
  'Ugandan UACE Points Grade',
  'WAEC Grading',
  'Zambian Points Grading',
  'Zimbabwe Class Grade',
]
